// bluaIQ — actor label: one shared shape + one client copy for "who did this".
//
// WHY. Codex found a raw Clerk id ("Subido por: user_3CEar4w") rendered to the
// client on the Drawings screen, and mandated a CROSS-SURFACE fix: one shared
// helper + a guard that bites on Planos / Documentos / Fotos, the client NEVER
// falling back to the raw id, and an unresolved user rendering the neutral copy
// "Miembro del equipo" / "Team member".
//
// This module is the CLIENT boundary. `ActorLabel` deliberately carries NO id —
// only a resolved kind (self / name / team_member). A raw Clerk id therefore
// cannot reach the DOM through here: it is structurally absent from the type.
// The server resolves stored ids into this shape BEFORE putting them on the wire
// (src/server/actorLabel.ts), the explicit-projection pattern the file-versions
// endpoint already uses — so the two latent leaks (documents, photos) are killed
// server-side before any surface renders them.

/** A client-safe "who did this" label. NO id field, by design. */
export type ActorLabel =
  | { kind: 'self' }
  | { kind: 'name'; name: string }
  | { kind: 'team_member' }

/** Render an actor label to client copy. Never returns a raw id — the type has
 *  none. `self` → «usted»/«you»; a resolved name → the name; anything else
 *  (unresolved, null, malformed) → the neutral "Miembro del equipo"/"Team
 *  member" (Codex ruling: no raw-id fallback, ever). */
export function actorLabelText(label: ActorLabel | null | undefined, isEs: boolean): string {
  if (label && label.kind === 'self') return isEs ? 'usted' : 'you'
  if (label && label.kind === 'name' && label.name.trim().length > 0) return label.name.trim()
  return isEs ? 'Miembro del equipo' : 'Team member'
}
